import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { GenericResponse } from 'http.interceptor';
import { HttpClient } from '@angular/common/http';
import { GenericResponse, SiteSettings } from '@app/models';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  updateUserSettings(settings: {
    firstName: string;
    lastName: string;
    companyName: string;
    phone: string;
  }): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(environment.apiUrl + '/api/Settings/UpdateUserSettings', settings);
  }

  getSiteSettings(): Observable<SiteSettings> {
    return this.http.get<SiteSettings>(`${environment.apiUrl}/api/Settings/GetSiteSettings`);
  }

  updateSiteSettings(settings: SiteSettings): Observable<any> {
    return this.http.post(environment.apiUrl + '/api/Settings/SaveSiteSettings', settings);
  }

  // Gets a list of Agencies that the current agency user can switch to.
  getAgenciesList(): Observable<
    | undefined
    | {
        token: string;
        name: string;
      }[]
  > {
    return this.http.post<
      {
        token: string;
        name: string;
      }[]
    >(environment.apiUrl + '/api/Settings/SettingsAgencyAccess', {});
  }

  switchAgency(agencyToken: string): Observable<GenericResponse> {
    // Gotta send in an object with token because somehow sending in a string is not working?
    return this.http.post<GenericResponse>(environment.apiUrl + '/api/Settings/UpdateAssignedAgency', {
      token: agencyToken,
      name: '',
    });
  }

  sendTestEmail(): Observable<unknown> {
    return this.http.post(environment.apiUrl + '/api/Settings/SendTestEmail', {});
  }

  getNotificationEmails(): Observable<{ email: string; id: number }[]> {
    return this.http.get<{ email: string; id: number }[]>(environment.apiUrl + '/api/Settings/GetNotificationEmails');
  }

  saveNotificationEmails(
    emails: { name: string; email: string; id: number; deleted?: boolean }[]
  ): Observable<unknown> {
    return this.http.post(environment.apiUrl + '/api/Settings/SaveNotificationEmails', emails);
  }

  changePassword(userId: string, newPassword: string): Observable<unknown> {
    return this.http.post(environment.apiUrl + '/api/Admin/ChangePassword', {
      id: userId,
      newPassword: newPassword,
    });
  }

  updateUserEmail(newEmail: string): Observable<unknown> {
    return this.http.post(environment.apiUrl + '/api/Settings/ChangeEmail', {
      email: newEmail,
    });
  }

  // requestNewConfirmation(): Observable<unknown> {
  //   return this.http.post(environment.apiUrl + '/api/Settings/RequestNewConfirmation', {});
  // }

  changeEmail(newEmail: string) {
    return this.http.post<string>(environment.apiUrl + '/api/Settings/ChangeEmail', {
      email: newEmail,
    });
  }

  confirmEmailChange(confirmationKey: string): Observable<string> {
    return this.http.post<string>(environment.apiUrl + '/api/Settings/ConfirmEmailChange', {
      key: confirmationKey,
    });
  }
}
